module.exports = __webpack_public_path__ + "9eb03ae8bc5967bfa939b713c39c2aea.jpg";